import "./index.css";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports, module) {
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames2;
        });
      } else {
        window.classNames = classNames2;
      }
    })();
  }
});

// src/MarkdownRenderer/MarkdownRenderer.tsx
var import_classnames = __toESM(require_classnames(), 1);
import * as React from "react";
import Box2 from "@cloudscape-design/components/box";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

// src/MarkdownRenderer/preprocessing.ts
var preprocessBulletPoints = (text) => {
  return text.replace(/^(\s*)•\s+/gm, "$1- ");
};
var preprocessEmojiLists = (text) => {
  return text.replace(/^(\s*)(?:✅|✓|⭐|🔹|▪️|◾|➡️|📌|🎯)\s*/gmu, "$1- ");
};
var ensureBlankLinesBeforeLists = (text) => {
  const lines = text.split("\n");
  const result = [];
  for (let i = 0; i < lines.length; i++) {
    const currentLine = lines[i];
    const prevLine = i > 0 ? lines[i - 1] : "";
    const isListItem = /^\s*(\d+\.|-|\*)\s+/.test(currentLine);
    const prevLineNotBlank = prevLine.trim() !== "";
    const prevIsListItem = /^\s*(\d+\.|-|\*)\s+/.test(prevLine);
    if (isListItem && prevLineNotBlank && !prevIsListItem) {
      result.push("");
    }
    result.push(currentLine);
  }
  return result.join("\n");
};
var preprocessMarkdown = (text) => {
  let processed = text;
  processed = preprocessBulletPoints(processed);
  processed = preprocessEmojiLists(processed);
  processed = ensureBlankLinesBeforeLists(processed);
  return processed;
};

// src/MarkdownRenderer/components.tsx
import Box from "@cloudscape-design/components/box";
import Header from "@cloudscape-design/components/header";
import Link from "@cloudscape-design/components/link";
import TextContent from "@cloudscape-design/components/text-content";
import { MessageRole } from "@amzn/awsmp-max-model";

// src/MarkdownRenderer/MarkdownRenderer.module.scss
var MarkdownRenderer_module_default = {
  user: "MarkdownRenderer_module_user",
  paragraph: "MarkdownRenderer_module_paragraph",
  link: "MarkdownRenderer_module_link",
  code: "MarkdownRenderer_module_code",
  heading1: "MarkdownRenderer_module_heading1",
  heading2: "MarkdownRenderer_module_heading2",
  heading3: "MarkdownRenderer_module_heading3",
  heading4: "MarkdownRenderer_module_heading4",
  list: "MarkdownRenderer_module_list",
  listItem: "MarkdownRenderer_module_listItem",
  blockquote: "MarkdownRenderer_module_blockquote",
  strong: "MarkdownRenderer_module_strong",
  emphasis: "MarkdownRenderer_module_emphasis",
  table: "MarkdownRenderer_module_table",
  thead: "MarkdownRenderer_module_thead",
  tbody: "MarkdownRenderer_module_tbody",
  tr: "MarkdownRenderer_module_tr",
  th: "MarkdownRenderer_module_th",
  td: "MarkdownRenderer_module_td"
};

// src/MarkdownRenderer/components.tsx
import { Fragment, jsx } from "react/jsx-runtime";
var getMarkdownComponents = (config = {}) => {
  const { processChildren: processChildrenProp, variant } = config;
  const processChildren = processChildrenProp || ((children) => children);
  const isUserMessage = variant === MessageRole.User;
  return {
    // Map markdown elements to Cloudscape components
    p: ({ children }) => /* @__PURE__ */ jsx(TextContent, { className: MarkdownRenderer_module_default.paragraph, children: /* @__PURE__ */ jsx("div", { style: { lineHeight: "1.6" }, children: processChildren(children) }) }),
    a: ({ href, children }) => /* @__PURE__ */ jsx(Link, { href, external: true, className: MarkdownRenderer_module_default.link, children: processChildren(children) }),
    // For user messages, render code/pre as plain text
    pre: isUserMessage ? ({ children }) => /* @__PURE__ */ jsx(Fragment, { children }) : void 0,
    code: ({ className, children }) => {
      if (isUserMessage) {
        return /* @__PURE__ */ jsx(Fragment, { children: processChildren(children) });
      }
      const isInline = !className;
      if (isInline) {
        return /* @__PURE__ */ jsx(
          "code",
          {
            className: MarkdownRenderer_module_default.code,
            style: {
              backgroundColor: "#f5f5f5",
              padding: "2px 4px",
              borderRadius: "3px",
              fontFamily: "monospace",
              fontSize: "0.9em"
            },
            children: processChildren(children)
          }
        );
      }
      return /* @__PURE__ */ jsx(Box, { margin: { vertical: "xs" }, children: /* @__PURE__ */ jsx(
        "pre",
        {
          className: MarkdownRenderer_module_default.code,
          style: {
            backgroundColor: "#f5f5f5",
            padding: "12px",
            borderRadius: "4px",
            overflow: "auto"
          },
          children: /* @__PURE__ */ jsx("code", { className: MarkdownRenderer_module_default.code, style: { fontFamily: "monospace", fontSize: "13px" }, children: processChildren(children) })
        }
      ) });
    },
    h1: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "s", top: "xs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h1", className: MarkdownRenderer_module_default.heading1, children: processChildren(children) }) }),
    h2: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "xs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h2", className: MarkdownRenderer_module_default.heading2, children: processChildren(children) }) }),
    h3: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "xxs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h3", className: MarkdownRenderer_module_default.heading3, children: processChildren(children) }) }),
    h4: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "xxs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h3", className: MarkdownRenderer_module_default.heading4, children: processChildren(children) }) }),
    ul: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { left: "l", vertical: "xs" }, children: /* @__PURE__ */ jsx("ul", { className: MarkdownRenderer_module_default.list, style: { paddingLeft: "20px" }, children: processChildren(children) }) }),
    ol: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { left: "l", vertical: "xs" }, children: /* @__PURE__ */ jsx("ol", { className: MarkdownRenderer_module_default.list, style: { paddingLeft: "20px" }, children: processChildren(children) }) }),
    li: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { bottom: "xxs" }, children: /* @__PURE__ */ jsx("li", { className: MarkdownRenderer_module_default.listItem, children: processChildren(children) }) }),
    blockquote: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { left: "m", vertical: "xs" }, padding: { left: "m" }, color: "text-body-secondary", children: /* @__PURE__ */ jsx("div", { className: MarkdownRenderer_module_default.blockquote, style: { borderLeft: "2px solid #d1d5db", paddingLeft: "12px" }, children: processChildren(children) }) }),
    hr: () => /* @__PURE__ */ jsx(Box, { margin: { vertical: "m" }, children: /* @__PURE__ */ jsx("hr", { style: { border: "0", borderTop: "1px solid #e1e4e8" } }) }),
    strong: ({ children }) => /* @__PURE__ */ jsx("strong", { className: MarkdownRenderer_module_default.strong, children: processChildren(children) }),
    em: ({ children }) => /* @__PURE__ */ jsx("em", { className: MarkdownRenderer_module_default.emphasis, children: processChildren(children) }),
    table: ({ children }) => /* @__PURE__ */ jsx(Box, { margin: { vertical: "m" }, children: /* @__PURE__ */ jsx("div", { style: { overflowX: "auto" }, children: /* @__PURE__ */ jsx(
      "table",
      {
        className: MarkdownRenderer_module_default.table,
        style: {
          width: "100%",
          borderCollapse: "collapse",
          border: "1px solid #e1e4e8"
        },
        children
      }
    ) }) }),
    thead: ({ children }) => /* @__PURE__ */ jsx("thead", { className: MarkdownRenderer_module_default.thead, children }),
    tbody: ({ children }) => /* @__PURE__ */ jsx("tbody", { className: MarkdownRenderer_module_default.tbody, children }),
    tr: ({ children }) => /* @__PURE__ */ jsx("tr", { className: MarkdownRenderer_module_default.tr, style: { borderBottom: "1px solid #e1e4e8" }, children }),
    th: ({ children }) => /* @__PURE__ */ jsx(
      "th",
      {
        className: MarkdownRenderer_module_default.th,
        style: {
          padding: "12px",
          textAlign: "left",
          fontWeight: "600",
          backgroundColor: "#e5e7eb",
          border: "1px solid #e1e4e8"
        },
        children: processChildren(children)
      }
    ),
    td: ({ children }) => /* @__PURE__ */ jsx(
      "td",
      {
        className: MarkdownRenderer_module_default.td,
        style: {
          padding: "12px",
          border: "1px solid #e1e4e8"
        },
        children: processChildren(children)
      }
    )
  };
};

// src/MarkdownRenderer/MarkdownRenderer.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var MarkdownRenderer = ({ children, processChildren, className, variant, allowHtml = false }) => {
  const preprocessedText = React.useMemo(() => preprocessMarkdown(children), [children]);
  const components = React.useMemo(() => getMarkdownComponents({ processChildren, variant }), [processChildren, variant]);
  const variantClass = variant ? MarkdownRenderer_module_default[variant] : void 0;
  const rehypePlugins = React.useMemo(() => allowHtml ? [rehypeRaw] : [], [allowHtml]);
  return /* @__PURE__ */ jsx2("div", { className: (0, import_classnames.default)(className, variantClass), children: /* @__PURE__ */ jsx2(Box2, { children: /* @__PURE__ */ jsx2(ReactMarkdown, { remarkPlugins: [remarkGfm], rehypePlugins, components, children: preprocessedText }) }) });
};
export {
  MarkdownRenderer,
  ensureBlankLinesBeforeLists,
  getMarkdownComponents,
  preprocessBulletPoints,
  preprocessEmojiLists,
  preprocessMarkdown
};
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/
//# sourceMappingURL=index.js.map
